import React, { useState, useEffect } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import {
  FiBox,
  FiStar,
  FiChevronLeft,
  FiChevronRight
} from 'react-icons/fi';
import { CiHome } from "react-icons/ci";
import { IoFolderOutline } from "react-icons/io5";
import '../assets/Sidebar.css';

export default function Sidebar() {
  const [collapsed, setCollapsed] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    setCollapsed(false);
  }, [pathname]);

  const menuItems = [
    { to: 'https://www.mixoutfit.com/', label: 'Inicio', Icon: CiHome   },
    { to: '/',  label: 'Probador Virtual', Icon: FiBox    },
    { to: '/files',   label: 'Mis archivos',     Icon: IoFolderOutline }
  ];

  return (
    <aside className={`sidebar${collapsed ? ' collapsed' : ''}`}>
      {/* Collapse button */}
      <button
        className="collapse-btn"
        onClick={() => setCollapsed(!collapsed)}
        aria-label={collapsed ? "Expandir menú" : "Colapsar menú"}
      >
        {collapsed ? <FiChevronRight /> : <FiChevronLeft />}
      </button>
  
      {/* Menú principal */}
      <ul className="menu">
        {menuItems.map(({ to, label, Icon }) => (
          <li key={to}>
            <NavLink
              to={to}
              end
              className={({ isActive }) =>
                'menu-item' + (isActive ? ' active' : '')
              }
            >
              <span className="icon-wrapper">
                <Icon
                  className={`menu-icon${label === 'Inicio' ? ' home-icon' : ''}`}
                />
              </span>
              {!collapsed && <span className="label">{label}</span>}
            </NavLink>
          </li>
        ))}
      </ul>
  
      {/* Sección PRO */}
      <div className="bottom">
        <NavLink
          to="/pricing"
          className={({ isActive }) =>
            'menu-item pro' + (isActive ? ' active' : '')
          }
        >
          {/* Fila superior: icono + título */}
          <div className="pro-header">
            <span className="icon-wrapper">
              <FiStar className="menu-icon" />
            </span>
            {!collapsed && (
              <span className="pro-title">Cambia a Plan PRO</span>
            )}
          </div>
          {/* Fila inferior: subtítulo */}
          {!collapsed && (
            <span className="pro-subtitle">
              Plantillas y nuevas funciones
            </span>
          )}
        </NavLink>
      </div>
    </aside>
  );
  
}
